/* Cosmopolitan landing page — set builder, sticky bar, discount auto-apply, dataLayer events.
   Config comes from the <script type="application/json" data-cosmo-config> block the section renders. */
(function () {
  'use strict';

  function dl(name, payload) {
    window.dataLayer = window.dataLayer || [];
    var obj = { event: name };
    if (payload) { for (var k in payload) { if (Object.prototype.hasOwnProperty.call(payload, k)) obj[k] = payload[k]; } }
    window.dataLayer.push(obj);
  }

  function mark(key) {
    try { sessionStorage.setItem(key, '1'); } catch (e) {}
    try { document.cookie = key + '=1; path=/; max-age=1800; samesite=lax'; } catch (e) {}
  }

  function isMarked(key) {
    try { if (sessionStorage.getItem(key)) return true; } catch (e) {}
    return document.cookie.indexOf(key + '=1') > -1;
  }

  /* Only ever redirect once, and never inside a theme preview or the theme editor.
     Three independent guards, because Shopify does not reliably preserve the query
     string it is handed in ?redirect= — which is what caused the reload loop. */
  function shouldAutoApply(cfg, params) {
    if (!cfg.autoApply || !cfg.code) return false;
    if (params.has('dm')) return false;
    if (params.has('preview_theme_id')) return false;
    if (window.Shopify && window.Shopify.designMode) return false;
    if (isMarked('cosmo_' + cfg.code)) return false;
    if (document.referrer && document.referrer.indexOf('/discount/') > -1) return false;
    return true;
  }

  /* One currency convention on the whole page: €133, no decimals unless the
     value has them, no space, U+2212 for a negative. Anything the theme would
     otherwise print through the Liquid `money` filter is routed through here
     so the page never shows two formats at once (defect 5A.2). */
  var CUR = '€';

  function money(cfg, cents) {
    var n = cents / 100;
    var sym = (cfg && cfg.cur) || CUR;
    return sym + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function initMoney(cfg) {
    if (cfg && cfg.cur) CUR = cfg.cur;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cosmo-money]'), function (n) {
      var cents = Number(n.getAttribute('data-cosmo-money'));
      if (!isNaN(cents)) n.textContent = money(cfg, cents);
    });
  }

  function pick(list, size, color) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].size === size && list[i].color === color) return list[i];
    }
    return null;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addToCart(items, onDone, onFail) {
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
    }
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'add failed');
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
          if (typeof drawer.open === 'function') drawer.open();
        } else {
          window.location.href = root() + 'cart';
        }
        if (onDone) onDone(data);
      })
      .catch(function (err) { if (onFail) onFail(err); });
  }

  function initBuilder(cfg) {
    var el = document.getElementById(cfg.root);
    if (!el || el.dataset.cosmoReady === '1') return;
    el.dataset.cosmoReady = '1';

    var sid = cfg.sectionId;
    var names = { color: 'cl-color-' + sid, bra: 'cl-bra-' + sid, thong: 'cl-thong-' + sid };

    var els = {
      add: el.querySelector('[data-cosmo-add]'),
      err: el.querySelector('[data-cosmo-error]'),
      braPrice: el.querySelector('[data-cosmo-braprice]'),
      thongPrice: el.querySelector('[data-cosmo-thongprice]'),
      braMemo: el.querySelector('[data-cosmo-bramemo]'),
      thongMemo: el.querySelector('[data-cosmo-thongmemo]'),
      savings: el.querySelector('[data-cosmo-savings]'),
      total: el.querySelector('[data-cosmo-total]'),
      heroPrice: el.querySelector('[data-cosmo-heroprice]'),
      sticky: document.querySelector('[data-cosmo-sticky]')
    };

    var fullSet = (cfg.bra.variants[0] ? cfg.bra.variants[0].price : 0) +
                  (cfg.thong.variants[0] ? cfg.thong.variants[0].price : 0);
    var discSet = Math.round(fullSet * (100 - cfg.pct) / 100);

    Array.prototype.forEach.call(document.querySelectorAll('[data-cosmo-full]'), function (n) {
      n.textContent = money(cfg, fullSet);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cosmo-disc]'), function (n) {
      n.textContent = money(cfg, discSet);
    });
    if (els.heroPrice) {
      els.heroPrice.innerHTML = '<span class="cl-was">' + money(cfg, fullSet) + '</span> &nbsp;' +
        '<span class="cl-money">' + money(cfg, discSet) + '</span> — ' + cfg.pct + '% off with ' + cfg.code;
    }

    function checked(name) {
      var input = el.querySelector('input[name="' + name + '"]:checked');
      return input ? input.value : null;
    }

    function state() {
      var color = checked(names.color);
      var braSize = checked(names.bra);
      var thongSize = checked(names.thong);
      return {
        color: color,
        bra: braSize ? pick(cfg.bra.variants, braSize, color) : null,
        thong: thongSize ? pick(cfg.thong.variants, thongSize, color) : null
      };
    }

    function syncAvailability(color) {
      Array.prototype.forEach.call(el.querySelectorAll('input[name="' + names.bra + '"]'), function (input) {
        var v = pick(cfg.bra.variants, input.value, color);
        input.disabled = !v || !v.available;
        if (input.disabled && input.checked) input.checked = false;
      });
      Array.prototype.forEach.call(el.querySelectorAll('input[name="' + names.thong + '"]'), function (input) {
        var v = pick(cfg.thong.variants, input.value, color);
        input.disabled = !v || !v.available;
        if (input.disabled && input.checked) input.checked = false;
      });
    }

    function render() {
      var s = state();
      syncAvailability(s.color);
      var braP = s.bra ? s.bra.price : (cfg.bra.variants[0] ? cfg.bra.variants[0].price : 0);
      var thongP = s.thong ? s.thong.price : (cfg.thong.variants[0] ? cfg.thong.variants[0].price : 0);
      var sum = braP + thongP;
      var final = Math.round(sum * (100 - cfg.pct) / 100);

      if (els.braPrice) els.braPrice.textContent = money(cfg, braP);
      if (els.thongPrice) els.thongPrice.textContent = money(cfg, thongP);
      if (els.braMemo) els.braMemo.textContent = s.bra ? (s.color + ' · ' + s.bra.size) : '';
      if (els.thongMemo) els.thongMemo.textContent = s.thong ? (s.color + ' · ' + s.thong.size) : '';
      if (els.savings) els.savings.textContent = '−' + money(cfg, sum - final);
      if (els.total) els.total.textContent = money(cfg, final);
      if (els.add) els.add.disabled = !(s.bra && s.thong);
    }

    var firstTouch = false;
    el.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('input[type="radio"]')) return;
      if (!firstTouch) {
        firstTouch = true;
        dl('cosmo_builder_engaged', {
          cosmo_first_choice: e.target.name.indexOf('color') > -1 ? 'colour' : 'size'
        });
      }
      render();
    });

    if (els.add) {
      els.add.addEventListener('click', function () {
        var s = state();
        if (!s.bra || !s.thong) return;
        els.add.disabled = true;
        if (els.err) els.err.hidden = true;

        addToCart(
          [{ id: s.bra.id, quantity: 1 }, { id: s.thong.id, quantity: 1 }],
          function () {
            dl('cosmo_set_added', {
              cosmo_colour: s.color,
              cosmo_bra_size: s.bra.size,
              cosmo_thong_size: s.thong.size,
              value: (s.bra.price + s.thong.price) / 100,
              currency: 'EUR'
            });
            render();
          },
          function (err) {
            if (els.err) {
              els.err.textContent = cfg.errorText;
              els.err.hidden = false;
            }
            dl('cosmo_set_add_failed', { cosmo_error: String(err && err.message ? err.message : err) });
            render();
          }
        );
      });
    }

    /* sticky bar appears once the hero is out of view */
    if (els.sticky && 'IntersectionObserver' in window) {
      var hero = el.querySelector('.cl-hero');
      if (hero) {
        els.sticky.hidden = false;
        new IntersectionObserver(function (entries) {
          els.sticky.classList.toggle('is-in', !entries[0].isIntersecting);
        }, { rootMargin: '-80px 0px 0px 0px' }).observe(hero);
      }
    }

    dl('cosmo_lp_view', { cosmo_code: cfg.code, cosmo_set_price: discSet / 100 });
    render();
  }

  function initAddons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cosmo-addon]') : null;
      if (!btn) return;
      var id = Number(btn.getAttribute('data-cosmo-addon'));
      var original = btn.textContent;
      var done = btn.getAttribute('data-cosmo-addon-done') || 'Added';
      btn.disabled = true;
      addToCart([{ id: id, quantity: 1 }],
        function () { dl('cosmo_addon_added', { cosmo_variant: id }); btn.textContent = done; },
        function () { btn.disabled = false; btn.textContent = original; });
    });
  }

  /* 5A.3 — consent wins, briefly. Two stacked bars on a 400px screen is worse
     than a delayed one, so the sticky buy bar stays down while a consent
     dialog is on screen and reveals when it goes. Gated on the element being
     visible, not on a timer, so it is not a race. */
  var CONSENT_SELECTORS = [
    '#CybotCookiebotDialog',
    '#onetrust-banner-sdk',
    '#cookiescript_injected',
    '#cookie-banner',
    '.cookie-banner',
    '.cookiebanner',
    '[id^="cookieConsent"]',
    '[class*="cookie-consent"]'
  ].join(',');

  function consentVisible() {
    var nodes;
    try { nodes = document.querySelectorAll(CONSENT_SELECTORS); } catch (e) { return false; }
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.offsetParent !== null && n.getBoundingClientRect().height > 8) return true;
    }
    return false;
  }

  function initConsentGate() {
    var pending = false;

    function apply() {
      var open = consentVisible();
      document.documentElement.classList.toggle('cosmo-consent-open', open);
      if (!open) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-cosmo-sticky]'), function (bar) {
          bar.classList.remove('cl-stickybar--waiting');
        });
      }
    }

    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; apply(); });
    }

    apply();

    if ('MutationObserver' in window && document.body) {
      new MutationObserver(schedule).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
      });
    }

    window.addEventListener('load', apply);
    document.addEventListener('click', schedule, true);
    setTimeout(apply, 1500);
    setTimeout(apply, 4000);
  }

  function initTracking() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cosmo-cta]'), function (a) {
      a.addEventListener('click', function () {
        dl('cosmo_cta_click', { cosmo_cta: a.getAttribute('data-cosmo-cta') });
      });
    });

    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = en.target.getAttribute('data-cosmo-track');
        if (id && !seen[id]) { seen[id] = true; dl('cosmo_section_view', { cosmo_section: id }); }
      });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cosmo-track]'), function (n) { obs.observe(n); });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-cosmo-config]');
    if (!nodes.length) return;

    var first = null;

    for (var i = 0; i < nodes.length; i++) {
      var cfg;
      try { cfg = JSON.parse(nodes[i].textContent); } catch (e) { continue; }
      if (!first) first = cfg;

      var params = new URLSearchParams(window.location.search);
      if (shouldAutoApply(cfg, params)) {
        mark('cosmo_' + cfg.code);
        params.set('dm', '1');
        var back = window.location.pathname + '?' + params.toString();
        window.location.replace('/discount/' + encodeURIComponent(cfg.code) +
          '?redirect=' + encodeURIComponent(back));
        return;
      }

      initBuilder(cfg);
    }

    initMoney(first);
    initAddons();
    initTracking();
    initConsentGate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-cosmo-config]').forEach(function (n) {
      var cfg;
      try { cfg = JSON.parse(n.textContent); } catch (e) { return; }
      var el = document.getElementById(cfg.root);
      if (el) { el.dataset.cosmoReady = ''; initBuilder(cfg); }
      initMoney(cfg);
    });
    initMoney(null);
  });
})();
